module.exports = __webpack_public_path__ + "static/media/account-journals.26e0b9ce.svg";